"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropType = exports.render = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("./component"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

/**
 * @param {*} Component
 * @return {boolean} false if `Component` is a plain function, `true` otherwise
 */
var isReactComponent = function isReactComponent(Component) {
  if (typeof Component !== 'function') return true;
  if (Component.prototype && Component.prototype.isReactComponent) return true;
  return Component.propTypes || Component.defaultProps;
};

var render = function render(Renderer, props) {
  return isReactComponent(Renderer) ? _react.default.createElement(Renderer, props) : Renderer(props);
};

exports.render = render;

var getPropType = function getPropType(_ref) {
  var propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps;
  return (0, _createChainablePropType.default)(_component.default, 'renderProp', {
    propTypes: propTypes,
    defaultProps: defaultProps
  });
};

exports.getPropType = getPropType;